export default __webpack_public_path__ + "static/media/MintDapp.ebf8650c.png";